import { FaPencilAlt, FaPlus, FaTrash } from "react-icons/fa";
import React, { useRef, useState } from "react";
import TableDataRender from "../../../components/common/TableDataRender";
import ModalWindow from "../../../components/ModalWindow";
import FormCreateCheese from "./forms/FormCreateCheese";
import FormCreateSideItem from "./forms/FormCreateSideItem";
import FormEditSideItem from "./forms/FormEditSideItem";
import { postData } from "../../../services/api.service";
import {
  swalAlertDanger,
  swalAlertSuccess,
  swalConfirmationAlert,
} from "../../../components/common/Alerts";

const AdminToppingsCheeses = ({ toppings, cheeses, sideItems, id_branch }) => {
  const tableRef = useRef();
  const [showModalCreateCheese, setShowModalCreateCheese] = useState(false);
  const [showModalCreateSideItem, setShowModalCreateSideItem] = useState(false);
  const [showModalEditSideItem, setShowModalEditSideItem] = useState(false);

  const [selectedSideItem, setSelectedSideItem] = useState(null);

  const handleDeleteTopping = async (item) => {
    swalConfirmationAlert("¿Está seguro de eliminar el topping?", "", () => {
      postData("/api/admin/delete_topping", item)
        .then((res) => {
          if (res.data.success) {
            swalAlertSuccess("Topping eliminado exitosamente", "", () => {
              window.location.reload();
            });
          } else {
            swalAlertDanger(res.data.msg, "", () => {});
          }
        })
        .catch((error) => {
          swalAlertDanger(
            "Error al eliminar el topping",
            "Si el error persiste, comuníquese con el administrador",
            () => {}
          );
        });
    });
  };

  const handleCreateCheese = async (data) => {
    const dataWithBranch = { ...data, id_branch };
    await postData("/api/admin/create_cheese", dataWithBranch)
      .then((res) => {
        if (res.data.success) {
          swalAlertSuccess("Queso creado exitosamente", "", () => {
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        swalAlertDanger(
          "Error al crear el queso",
          "Si el error persiste, comuníquese con el administrador",
          () => {}
        );
      });
  };

  const handleDeleteCheese = async (item) => {
    swalConfirmationAlert("¿Está seguro de eliminar el queso?", "", () => {
      postData("/api/admin/delete_cheese", item)
        .then((res) => {
          if (res.data.success) {
            swalAlertSuccess("Queso eliminado exitosamente", "", () => {
              window.location.reload();
            });
          } else {
            swalAlertDanger(res.data.msg, "", () => {});
          }
        })
        .catch((error) => {
          swalAlertDanger(
            "Error al eliminar el queso",
            "Si el error persiste, comuníquese con el administrador",
            () => {}
          );
        });
    });
  };

  const handleCreateSideItem = async (data) => {
    const dataWithBranch = { ...data, id_branch };
    await postData("/api/admin/create_side_item", dataWithBranch)
      .then((res) => {
        if (res.data.success) {
          swalAlertSuccess("Extra de papas creado exitosamente", "", () => {
            setShowModalCreateSideItem(false);
            window.location.reload();
          });
        } else {
          swalAlertDanger(res.data.msg, "", () => {});
        }
      })
      .catch((error) => {
        swalAlertDanger(
          "Error al crear el extra de papas",
          "Si el error persiste, comuníquese con el administrador",
          () => {}
        );
      });
  };

  const handleEditSideItem = async (editedData) => {
    await postData("/api/admin/update_side_item", editedData)
      .then((res) => {
        if (res.data.success) {
          swalAlertSuccess(
            "Extra de papas actualizado exitosamente",
            "",
            () => {
              setShowModalEditSideItem(false);
              window.location.reload();
            }
          );
        } else {
          swalAlertDanger(res.data.msg, "", () => {});
        }
      })
      .catch((error) => {
        swalAlertDanger(
          "Error al actualizar el extra de papas",
          "Si el error persiste, comuníquese con el administrador",
          () => {}
        );
      });
  };

  const handleDeleteSideItem = async (item) => {
    swalConfirmationAlert(
      "¿Está seguro de eliminar el extra de papas?",
      "",
      () => {
        postData("/api/admin/delete_side_item", item)
          .then((res) => {
            if (res.data.success) {
              swalAlertSuccess(
                "Extra de papas eliminado exitosamente",
                "",
                () => {
                  window.location.reload();
                }
              );
            } else {
              swalAlertDanger(res.data.msg, "", () => {});
            }
          })
          .catch((error) => {
            console.error("Error al eliminar el extra de papas:", error);
            swalAlertDanger(
              "Error al eliminar el extra de papas",
              "Si el error persiste, comuníquese con el administrador",
              () => {}
            );
          });
      }
    );
  };

  const columnMappingCheeses = {
    QUESO: { key: "cheese_description", dataType: "text", align: "center" },
    ELIMINAR: {
      key: "delete",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => handleDeleteCheese(item.id)}
          className="btn btn-danger"
        >
          <FaTrash />
        </button>
      ),
    },
  };

  const columnMappingToppings = {
    TOPPING: { key: "topping_name", dataType: "text", align: "center" },
    ELIMINAR: {
      key: "delete",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => handleDeleteTopping(item.id)}
          className="btn btn-danger"
        >
          <FaTrash />
        </button>
      ),
    },
  };

  const columnMappingSideItem = {
    "TIPO DE EXTRA": { key: "addon_name", dataType: "text", align: "center" },
    "PRECIO EXTRA": {
      key: "extra_price",
      dataType: "text",
      align: "center",
    },
    EDITAR: {
      key: "edit",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => {
            setSelectedSideItem(item);
            setShowModalEditSideItem(true);
          }}
          className="btn btn-info"
        >
          <FaPencilAlt />
        </button>
      ),
    },
    ELIMINAR: {
      key: "delete",
      dataType: "button",
      align: "center",
      render: (item) => (
        <button
          onClick={() => handleDeleteSideItem(item.id)}
          className="btn btn-danger"
        >
          <FaTrash />
        </button>
      ),
    },
  };

  return (
    <>
      <div className="container-fluid mt-4">
        <h3 style={{ color: "#E8D9CD" }} className="text-center mb-4 ">
          Quesos y Toppings
        </h3>

        <div className="row g-3">
          <div className="col-12 col-md-6">
            <div className="card shadow-sm p-3">
              <div className="row align-items-center mb-3">
                <div className="col-6">
                  <h5 className="text-center mb-0">Agrega o elimina quesos</h5>
                </div>
                <div className="col-6 text-center">
                  <button
                    className="btn btn-success"
                    onClick={() => setShowModalCreateCheese(true)}
                  >
                    <FaPlus /> Nuevo queso
                  </button>
                </div>
              </div>
              <TableDataRender
                data={cheeses}
                columnMapping={columnMappingCheeses}
                tableRef={tableRef}
              />
            </div>
            <div>
              <div className="card shadow-sm p-3 mt-3">
                <div className="row align-items-center mb-3">
                  <div className="col-6">
                    <h5 className="text-center mt-3">Extras de papas</h5>
                  </div>
                  <div className="col-6 text-center">
                    <div className="col-6 text-center">
                      <button
                        className="btn btn-success"
                        onClick={() => setShowModalCreateSideItem(true)}
                      >
                        <FaPlus /> Nuevo extra
                      </button>
                    </div>
                  </div>
                </div>
                <TableDataRender
                  data={sideItems}
                  columnMapping={columnMappingSideItem}
                  tableRef={tableRef}
                />
              </div>
            </div>
          </div>

          <div className="col-12 col-md-6">
            <div className="card shadow-sm p-3">
              <h5 className="text-center mb-3">Elimina toppings</h5>
              <TableDataRender
                data={toppings}
                columnMapping={columnMappingToppings}
                tableRef={tableRef}
              />
            </div>
          </div>
        </div>
      </div>
      <ModalWindow
        body={<FormCreateCheese handleCreateCheese={handleCreateCheese} />}
        modalOpen={showModalCreateCheese}
        setModalOpen={setShowModalCreateCheese}
        footer={
          "La opción añadida se mostrará en la lista de quesos disponibles para las hamburguesas."
        }
      />
      <ModalWindow
        title={"Crear Extra de Papas"}
        body={
          <FormCreateSideItem handleCreateSideItem={handleCreateSideItem} />
        }
        modalOpen={showModalCreateSideItem}
        setModalOpen={setShowModalCreateSideItem}
        footer={
          "La opción añadida se mostrará en la lista de extras de papas disponibles."
        }
      />
      <ModalWindow
        title={"Editar Extra de Papas"}
        body={
          <FormEditSideItem
            handleEditSideItem={handleEditSideItem}
            selectedSideItem={selectedSideItem}
          />
        }
        modalOpen={showModalEditSideItem}
        setModalOpen={setShowModalEditSideItem}
        footer={
          "Los cambios se aplicarán a todos los extras de papas existentes."
        }
      />
    </>
  );
};

export default AdminToppingsCheeses;
